export const ApiControllers = {
    projects: "Projects/",
    customer: "Customer/",
    common: "Common/",
    adminbankbuy: "AdminBankBuy/",
    cryptoExchange: "CryptoExchange/",
    transactions: "Transactions/",
    bank: "Bank/",
    addressbook: "Addressbook/",
    security: "Security/",
    master: "Master/",
    withdraw:"Withdraw/",
    deposit:"Deposit/",
    banks:"Banks/",
    cards:"Cards/",
    allCards:'CardsWallet/',
    commissions : "Commissions/",
    registration:"Registration/",
    dashboardController:"DashBoard/",
    exchangetransaction:'ExchangeTransaction/',
    exchangeWallet:'ExchangeWallet/',
    case:'Case/'
}

